module.exports = __webpack_public_path__ + "img/smw-library05.91ffc527.jpg";